module.exports = __webpack_public_path__ + "04_long_beige.41f2adc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_long_beige.png
// module id = 11Y1
// module chunks = 0